// // 设置 rem 函数
// function setRem() {
//   // 320 默认大小16px; 320px = 20rem ;每个元素px基础上/16
//   let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
//   //得到html的Dom元素
//   let htmlDom = document.getElementsByTagName('html')[0];
//   //设置根元素字体大小
//   htmlDom.style.fontSize = htmlWidth / 20 + 'px';

// }
// // 初始化
// setRem();
// // 改变窗口大小时重新设置 rem
// window.onresize = function () {
//   setRem()
// }

(function (doc, win) {
	
  var docEl = doc.documentElement,
     resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
     recalc = function () {
     var clientWidth = docEl.clientWidth;
     if (!clientWidth) return;
     docEl.style.fontSize = 24 * (clientWidth / 640) + 'px';
   document.body.style.fontSize = 24 * (clientWidth / 640) + 'px';
  };
  
if (!doc.addEventListener) return;
win.addEventListener(resizeEvt, recalc, false);
doc.addEventListener('DOMContentLoaded', recalc, false);

  

})(document, window);